import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

/**
 * Returns the default home path for a given role.
 */
export const getDefaultPath = (role) => {
    switch (role) {
        case 'Sales':
            return '/employee';
        case 'Finance':
            return '/finance';
        case 'Owner':
        case 'Admin':
        default:
            return '/';
    }
};

/**
 * ProtectedRoute — wraps routes that require specific roles.
 *
 * Usage (nested routes pattern):
 *   <Route element={<ProtectedRoute allowedRoles={['Owner','Admin']} activeUser={activeUser} />}>
 *     <Route path="/leads" element={<LeadsView />} />
 *   </Route>
 *
 * If the user's role is NOT in allowedRoles, they are redirected to their
 * default page (getDefaultPath). The `replace` prop prevents the restricted
 * URL from being stored in browser history.
 */
export default function ProtectedRoute({ allowedRoles, activeUser }) {
    const role = activeUser?.role;

    if (!role || !allowedRoles.includes(role)) {
        return <Navigate to={getDefaultPath(role)} replace />;
    }

    return <Outlet />;
}
